module.exports = __webpack_public_path__ + "media/2.2_super_adjectives_tarjeta_avatar_kitten_cf1.c7a1625f.wav";